import { useTeamTree } from '@internal/backstage-plugin-common-react';
import { DateTime } from 'luxon';
import { createContext, useContext, useMemo } from 'react';

import { useEntity } from '@backstage/plugin-catalog-react';

import { useGetCategoriesData } from '../hooks/useGetCategoriesData';
import type { CategoryData } from '../types';
import { toStandardISO } from '../utils';

interface ScorecardDataContextType {
  categoriesData: CategoryData[] | null;
  loading: boolean;
}

const ScorecardDataContext = createContext<ScorecardDataContextType>({
  categoriesData: null,
  loading: true,
});

export const ScorecardDataProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { entity } = useEntity();
  const orgId = entity.metadata.annotations?.['tomtom.com/org-id'];
  const { tree } = useTeamTree(orgId);
  const teamTreeData = useMemo(() => tree, [tree]);

  const startDate = useMemo(
    () => toStandardISO(DateTime.now().startOf('month')),
    [],
  );
  const endDate = useMemo(
    () => toStandardISO(DateTime.now().endOf('month')),
    [],
  );

  const { loading, value: categoriesData } = useGetCategoriesData(
    teamTreeData,
    startDate,
    endDate,
    'month',
  );

  return (
    <ScorecardDataContext.Provider value={{ categoriesData, loading }}>
      {children}
    </ScorecardDataContext.Provider>
  );
};

export const useScorecardData = () => useContext(ScorecardDataContext);